var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4465 15.447L10.9736 16.9199L6.55273 12.5001L10.9725 8.08032L12.4454 9.55428L10.5423 11.4584H18.3934V13.5418H10.5423L12.4465 15.447Z",
    fill: "url(#paint0_linear_4239_1007)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9587 19.7917C23.9587 20.8968 23.5197 21.9566 22.7383 22.738C21.9569 23.5194 20.8971 23.9584 19.792 23.9584H5.20866C4.10359 23.9584 3.04378 23.5194 2.26238 22.738C1.48098 21.9566 1.04199 20.8968 1.04199 19.7917V5.20841C1.04199 4.10335 1.48098 3.04354 2.26238 2.26214C3.04378 1.48073 4.10359 1.04175 5.20866 1.04175H19.792C20.8971 1.04175 21.9569 1.48073 22.7383 2.26214C23.5197 3.04354 23.9587 4.10335 23.9587 5.20841V19.7917ZM19.792 21.8751H5.20866C4.65612 21.8751 4.12622 21.6556 3.73552 21.2649C3.34482 20.8742 3.12533 20.3443 3.12533 19.7917V5.20841C3.12533 4.65588 3.34482 4.12598 3.73552 3.73528C4.12622 3.34457 4.65612 3.12508 5.20866 3.12508H19.792C20.3445 3.12508 20.8744 3.34457 21.2651 3.73528C21.6558 4.12598 21.8753 4.65588 21.8753 5.20841V19.7917C21.8753 20.3443 21.6558 20.8742 21.2651 21.2649C20.8744 21.6556 20.3445 21.8751 19.792 21.8751Z",
    fill: "url(#paint1_linear_4239_1007)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4239_1007",
    x1: 12.473,
    y1: 8.08032,
    x2: 12.473,
    y2: 16.9199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4239_1007",
    x1: 12.5003,
    y1: 1.04175,
    x2: 12.5003,
    y2: 23.9584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBack);
export default __webpack_public_path__ + "static/media/arrow-leftBack.40533de3f69a01e52320535c0d87694b.svg";
export { ForwardRef as ReactComponent };